<template>
  <form action="/">
    <Error/>
    <div class="authorize-container">
      <TypeAuth
        :field="getFieldByCode('isPhone')"
        text="Тип авторизации"
        @change="onChangeInput"/>
      <Phone
        v-if="isPhone"
        :field="getFieldByCode('phone')"
        text="Телефон"
        @change="onChangeInput"/>
      <Email
        v-else
        :field="getFieldByCode('email')"
        text="Email"
        @change="onChangeInput"/>
      <Password
        :field="getFieldByCode('password')"
        text="Пароль"
        @change="onChangeInput"/>
    </div>
    <AuthLinks :is-phone="isPhone" @login="onLogin"/>
  </form>
</template>

<script>
  import Email from '../Inputs/Email'
  import TypeAuth from '../Inputs/TypeAuth'
  import Phone from '../Inputs/Phone'
  import Password from '../Inputs/Password'
  import AuthLinks from './AuthLinks'
  import {mapActions} from 'vuex'
  import Error from './Error'

  export default {
    name: 'AuthForm',
    components: {
      Email,
      TypeAuth,
      Phone,
      Password,
      AuthLinks,
      Error
    },
    data: function () {
      return {
        fields: [
          {
            code: 'isPhone',
            type: 'switch',
            value: true
          },
          {
            code: 'phone',
            type: 'phone',
            value: ''
          },
          {
            code: 'email',
            type: 'email',
            value: ''
          },
          {
            code: 'password',
            type: 'password',
            value: ''
          }
        ]
      }
    },
    computed: {
      isPhone: function () {
        return this.getFieldByCode('isPhone').value
      }
    },
    methods: {
      ...mapActions('auth', [
        'login',
        'loginByPhone'
      ]),
      getFieldByCode: function (code) {
        return this.fields.find(e => e.code === code)
      },
      onChangeInput: function (entity) {
        const filed = this.getFieldByCode(entity.code)
        filed.value = entity.value
      },
      onLogin: function () {
        if (this.isPhone) {
          this.loginByPhone({
            phone: this.getFieldByCode('phone').value,
            password: this.getFieldByCode('password').value
          })
        } else {
          this.login({
            login: this.getFieldByCode('email').value,
            password: this.getFieldByCode('password').value
          })
        }
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/Auth/Authorize/AuthForm.vue